export default __webpack_public_path__ + "static/bg-hcuk-04e028977448f23aa0f029bf00244c5b.webp";